import React from 'react'
import './EmptyData.sass'

function EmptyData({ title = 'empty data' }) {
  return <p className="EmptyData">{title}</p>
}

export default EmptyData
